export default __webpack_public_path__ + "static/ai-test-automation-42aed93f8b84e6a201b0ade670b6ff1f.png";